/*
 * @Author: puxiao.wh
 * @Date: 2019-01-14 10:51:53
 * @LastEditors: puxiao.wh
 * @LastEditTime: 2019-01-18 11:42:52
 * @Description:  
 */

const jplusPluginProbe = {
    init() {
        const { setPluginFun } = jplusUtil
        setPluginFun('probe', 'jplusPluginLoadedGoldlog', this.jplusPluginLoadedGoldlog)
        setPluginFun('probe', 'jplusPluginFunGoldlog', this.jplusPluginFunGoldlog)
        this.configParser()
    },
    jplusPluginLoadedGoldlog() {
        const { $get } = jplusUtil || {}
        const keys = Object.keys(window.jplus.pluginInfo)
        // window.jplus.pluginInfo && window.jplus.pluginInfo.map((plugin, index) => {
        //     if(plugin.isRecord === false) {
        //         $get && $get(`http://gm.mmstat.com/jplus.plugin.exp?jplus_plugin_version=${plugin.version}&jplus_plugin_name=${plugin.name}&URL=${encodeURIComponent(location.href)}&t=${(new Date).getTime()}`)
        //         window.jplus.pluginInfo[index].isRecord = true
        //     }
        // })

        keys.map((key) => {
            const pluginInfo = window.jplus.pluginInfo[key]
            if(pluginInfo.isRecord === false) {
                $get && $get(`//gm.mmstat.com/jplus.plugin.exp?jplus_plugin_version=${pluginInfo.version}&jplus_plugin_name=${pluginInfo.name}&URL=${encodeURIComponent(location.href)}&t=${(new Date).getTime()}`)
                window.jplus.pluginInfo[key].isRecord = true
            }
        })
    },
    // 监控插件方法
    jplusPluginFunGoldlog(options) {
        const { $get } = window.jplusUtil
        const { pluginName, funName } = options
        $get(`//gm.mmstat.com/jplus.plugin-probe.funname?plugin_name=${pluginName}&fun_name=${funName}&URL=${location.href}&t=${Date.now()}`)
    },
    configParser() {
        const { getConfig } = jplusUtil || {}
        const config = getConfig('probe')
        config && config.forEach((item) => {
            this.jsversion(item)
        })
    },
    jsversion(options = {}) {
        if (options.key && options.key.search(/^\/.*(\.js)$/) > -1) {
            this.retCode({
                key: options.key,
                value: options.value
            })
        } else {
            console.warn('该脚本未上报成功，请使用该格式（/app/probe/probe.js）进行上报，以「/」开头，以「.js」结尾: ' + key)
        }
    },
    retCode(options = {
        key: '',
        value: '0.0.0'
    }) {
        const prefix = 'jplus-plugin-probe'
        let log = `${prefix}_${options.key}_${options.value}`
        const params = {
            api: options.key,
            issuccess: true,
            delay: 100,
            msg: options.value,
            detail: log,
            traceId: undefined //和后端同学商量好如何获取接口请求的traceId
        }
        if (typeof (window.__WPO) === "object") {
            window.__WPO.retCode(params)
        } else {
            const { importPlugin } = window.jplusUtil || {}
            const scripts = 'https://g.alicdn.com/retcode/log/log.js'
            importPlugin(scripts, () => {
                if (typeof (window.__WPO) === "object") {
                    window.__WPO.retCode(params)
                }
            })
        }
    }
}

jplusPluginProbe.init()

export default jplusPluginProbe
